import { useEffect, useRef } from 'react';
import type { Object3D, SpotLight } from 'three';
import type { CarBounds } from '../types';

function HeadlightBeam({
  position,
  targetPosition,
}: {
  position: [number, number, number];
  targetPosition: [number, number, number];
}) {
  const lightRef = useRef<SpotLight | null>(null);
  const targetRef = useRef<Object3D | null>(null);

  useEffect(() => {
    if (lightRef.current && targetRef.current) {
      lightRef.current.target = targetRef.current;
    }
  }, []);

  return (
    <>
      <spotLight
        ref={lightRef}
        position={position}
        color="#e8f2ff"
        intensity={95}
        distance={46}
        angle={0.24}
        penumbra={0.68}
        decay={1.7}
        castShadow={false}
      />
      <object3D ref={targetRef} position={targetPosition} />
    </>
  );
}

/** 모델 실측 bounds에서 좌우 램프 위치를 추정해 밤에 자동 점등합니다. */
export function VehicleHeadlights({ bounds }: { bounds: CarBounds }) {
  const x = bounds.frontX - Math.min(0.32, (bounds.frontX - bounds.rearX) * 0.06);
  const y = Math.max(0.42, Math.min(0.78, bounds.roofY * 0.47));
  const z = Math.max(0.36, bounds.halfWidth * 0.62);
  const targetX = bounds.frontX + 38;

  return (
    <>
      <HeadlightBeam position={[x, y, -z]} targetPosition={[targetX, -0.45, -z * 0.55]} />
      <HeadlightBeam position={[x, y, z]} targetPosition={[targetX, -0.45, z * 0.55]} />
      {[-z, z].map((lampZ) => (
        <mesh key={lampZ} position={[x + 0.006, y, lampZ]} rotation={[0, Math.PI / 2, 0]}>
          <circleGeometry args={[0.075, 18]} />
          <meshBasicMaterial color="#eaf4ff" toneMapped={false} />
        </mesh>
      ))}
    </>
  );
}
